module.exports = __webpack_public_path__ + "static/assets/f4562fc422632e151507bca34b72e24a.svg";